import React from "react";
import {checkLockStatus} from "../compare/compare.method";

import {Change} from "../compare/Change";

const BuildMissingCompetitor = ({t,vehicle,isLocked,id,vehicleData,openModal,handleModalClose,secondaryYear,vehiclesMakes,vehicleModel
                                    , driveType,trimModel, setTrimModel, setVehicleMake, setVehicleData, vehiclesTrim, vehicleIndex, vehicleTypeName,getCompareImages
                                        , setDriveType,setVehicleModel, changeHandler,setOpenModal, maxSmallScreenWidth, headerLoadType }) => {
    const missingCompetitorDivs = Math.max(0, Math.min(2, 4 - getCompareImages.length));

    return(
      [...Array(maxSmallScreenWidth ? missingCompetitorDivs : 4 - getCompareImages.length)].map((_, i) => (

          <div className={'secondaryVehicle'}  key={`no-vehicle-selected-${i}`}>
                 <div className={'competitor-image'}>
                     <div className="no-vehicle"> {t('overview.noVehicleSelected')}</div>
                 </div>
                 <div className={'competitor-details'}>
                     <div className={'no-vehicle-change'}>
                         <button
                             id={getCompareImages?.length}
                             className={checkLockStatus(vehicle, isLocked,id) ? `btn-default ${headerLoadType ? "jdpa-button-disabled" : "btn-change-disabled"}` : "btn-default btn-change-compare"}                             value={""}
                             onClick={(event) => changeHandler(getCompareImages?.length, "")}
                             disabled={isLocked && isLocked[id]}
                         >
                             {t('overview.controls.selectVehicle')}
                         </button>
                         <Change
                             vehicleData={vehicleData}
                             setVehicleData={setVehicleData}
                             openModal={openModal}
                             handleModalClose={handleModalClose}
                             years={secondaryYear}
                             vehicleMake={vehiclesMakes}
                             vehicleModels={vehicleModel}
                             trimModel={trimModel}
                             setTrimModel={setTrimModel}
                             setVehicleModel={setVehicleModel}
                             setVehicleMake={setVehicleMake}
                             vehiclesTrim={vehiclesTrim}
                             vehicleIndex={vehicleIndex}
                             vehicleTypeName={vehicleTypeName}
                             driveType={driveType}
                             setOpenModal={setOpenModal}
                             setDriveType={setDriveType}
                             lockedVehicle={isLocked}
                         />
                     </div>
                 </div>
             </div>
      ))
  );
}

export default BuildMissingCompetitor;